import React from "react";

export default function SessionsTable() {
  return (
    <div className="ia-placeholder">
      <h3>📄 SessionsTable</h3>
      <p>Tabela de sessões será renderizada aqui.</p>
    </div>
  );
}
